// eslint-disable-next-line import/no-unresolved
module.exports = require('./build/OutsideClickHandler');